import { useUser } from "@/context/user-context";
import { useGetReportsByPromptId } from "@/queries/evals/useGetReportsByPromptId";
import { useParams } from "react-router-dom";
import { useHistoryFilters } from "../../ControlBar/HistoryFilter/history-filter-store";
import { useMemo, useState } from "react";

const useReportData = ({
  usePromptId,
  useParentReportId,
  displayAll,
}: {
  usePromptId: boolean;
  useParentReportId: boolean;
  displayAll: boolean;
}) => {
  const workspaceId = useUser()?.activeWorkspaceId;
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const filter = useHistoryFilters();
  const { promptId, blueprintId } = useParams();

  const selectedEvaluationId = filter.selectedEvaluationId;
  const selectedDatasetId = filter.selectedDatasetId;
  const selectedLabelId = filter.selectedLabelId;
  const selectedVersionId = filter.selectedVersionId;
  const selectedDateRange = filter.selectedDateRange;

  const result = useGetReportsByPromptId({
    workspace_id: workspaceId!,
    prompt_id: usePromptId ? Number(promptId) : undefined,
    page: page,
    is_blueprint: false,
    per_page: pageSize,
    dataset_id: selectedDatasetId ? Number(selectedDatasetId) : undefined,
    prompt_label_id: selectedLabelId,
    prompt_version_id: selectedVersionId,
    parent_report_id: useParentReportId
      ? Number(blueprintId)
      : selectedEvaluationId
      ? Number(selectedEvaluationId)
      : undefined,
    start_time: selectedDateRange?.from?.toISOString(),
    end_time: selectedDateRange?.to?.toISOString(),
    include_datasets: true,
    include_columns: true,
  });

  return useMemo(
    () => ({
      reports: displayAll
        ? result.data?.reports
        : result.data?.reports.filter((report) => report.score !== null),
      isLoading: result.isLoading || result.isRefetching || result.isFetching,
      pageCount: result.data?.pages,
      setPageSize,
      setPage,
      page,
      pageSize,
      hasNext: result.data?.has_next,
    }),
    [
      result.data?.reports,
      result.isLoading,
      result.isRefetching,
      result.isFetching,
      displayAll,
      result.data?.pages,
      page,
      pageSize,
      result.data?.has_next,
    ],
  );
};

export default useReportData;
